import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';

export interface IProduct extends IModel {
	vendorKey?: string;
	productLineKey?: string;
	name?: string;
	cost?: number;
	sku?: string;
	defaultSell?: number;
	inactive?: boolean;
}

const productFactory = modelFactory.createFactory<IProduct>('Product', _.assign({}, model, {

	vendorKey: {
		setFilters: valueFilters.clean
	},
	productLineKey: {
		setFilters: valueFilters.clean
	},
	name: {
		rules: validator.required()
	},
	cost: {
		setFilters: valueFilters.cleanNumber,
		getFilters: valueFilters.toNumber,
		rules: validator.required()
	},
	sku: {
		rules: validator.required()
	},
	defaultSell: {
		setFilters: valueFilters.cleanNumber,
		getFilters: valueFilters.toNumber
	},
	inactive: {
		setFilters: valueFilters.toBoolean
	}
}));

export default productFactory;